
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { ArrowLeft } from "lucide-react";

interface LensDetailsSkeletonProps {
  onBackClick: () => void;
}

export function LensDetailsSkeleton({ onBackClick }: LensDetailsSkeletonProps) {
  return (
    <div className="container py-6 space-y-6 max-w-[1200px] mx-auto">
      <div className="flex items-center gap-2 mb-6">
        <Button variant="outline" size="sm" onClick={onBackClick}>
          <ArrowLeft className="h-4 w-4 mr-1" />
          Back to Lenses
        </Button>
      </div>
      
      <Card className="mb-6">
        <CardHeader>
          <Skeleton className="h-8 w-3/4 mb-2" />
          <Skeleton className="h-4 w-1/2" />
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-3/4" />
            <Skeleton className="h-4 w-1/2" />
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
